import React from 'react';

const Loading = () => {
    return (
        <div className="flex justify-center items-center min-h-screen">
            <button className="btn loading">loading</button>
        </div>
    );
};

export default Loading;